import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiEmptyImageComponent } from './ui-empty-image.component';

@Component({
    selector: 'app-safe-image',
    standalone: true,
    imports: [CommonModule, UiEmptyImageComponent],
    template: `
    <app-ui-empty-image *ngIf="!src || error()" [iconClass]="iconClass"></app-ui-empty-image>
    <img
      *ngIf="src && !error()"
      [src]="src"
      [alt]="alt"
      (error)="error.set(true)"
      loading="lazy" decoding="async"
      [class]="imgClass"
    />
    `
})
export class SafeImageComponent {
    @Input() src: string | null | undefined;
    @Input() alt = '';
    @Input() iconClass = 'w-7 h-7';
    @Input() imgClass = 'w-full h-full object-cover';

    error = signal(false);
}
